import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link, Typography } from "@mui/material";
import RequestViewDetailsVendor from "components/Admin/Note/RequestViewDetailsVendor";

class RequestViewDetailsVendorContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
    };
  }

  componentDidMount() {
    let VendorViewId;
    if (this.props?.location?.VendorViewDetailId?.id) {
      localStorage.setItem(
        "VendorViewId",
        JSON.stringify(this.props?.location?.VendorViewDetailId?.id)
      );
      VendorViewId = this.props?.location?.VendorViewDetailId?.id;
    } else {
      VendorViewId = localStorage.getItem("VendorViewId");
      if (VendorViewId) VendorViewId = JSON.parse(VendorViewId);
    }
    if (VendorViewId) {
      this.props.getRequestViewDetailsVendorAction({ id: VendorViewId });
    }
  }

  render() {
    const data = this.props?.RequestViewVendorList?.result;

    return (
      <Grid container>
        <Stack p={0.5} mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link
              sx={{ fontSize: "14px" }}
              underline="hover"
              color="#A2A7AE"
              href="/vendor/request "
            >
              Request
            </Link>
            <Typography sx={{ fontSize: "14px" }} color="#0DA861">
              {this.props?.location?.VendorViewDetailId?.name}
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid item xs={12}>
          <Paper sx={{ p: 3, mt: 1 }}>
            <RequestViewDetailsVendor data={data} />
          </Paper>
        </Grid>
      </Grid>
    );
  }
}
export default RequestViewDetailsVendorContainer;
